import { 
    Heading, 
    Box,
    Text,
    SimpleGrid,
    Container,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
  } from '@chakra-ui/react'
import { ArrowForwardIcon } from "@chakra-ui/icons"

const containerMW = '800px'
const currentHost = `${window.location.protocol}//${window.location.hostname}`;


function HPLSFormHeader() {
    return (
    <>
        <Box w='100%' bg='piacred.500' p={4}><Heading as='h2' id='hpls-main-title' fontSize={{ base: '1.8rem', md: '2.6rem', xl: '2.8rem' }} color='white' py={6}>
        <ArrowForwardIcon w={6} h={6} mb={0.5} mr={1} aria-hidden="true" />Apply for legal help</Heading>
        </Box>
        <Container id='hpls-form-intro' maxWidth={containerMW} py={10} px={6} border='0px' bg='piacgray.300'>
            <Text fontSize={{ base: '1rem', md: '1.1rem', xl: '1.2rem' }} fontWeight='600' color="#333333" mb={6}>Please fill in the questions that apply to you. The questions you must answer are marked with <Text as='span' color='piacred.500' fontWeight='600'>*</Text>. We will aim to get back to you within three business days.</Text>
            <SimpleGrid id='hpls-intro-help-buttons' mt={2} mb={1} columns={[1,3]} spacing={2}>
                <PrivacyModal />
                <InterpreterModal />
                <NeedHelpModal />
                </SimpleGrid>
        </Container>
    </>
)}

function InterpreterModal() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    
    return (
        <>
        <Button onClick={onOpen}
            aria-label="Free interpreter service"
            bg='piacyellow.500'
            border='1px solid black'
            color='black'
            rounded='none'
            _hover={{ 
              bg: 'piacred.500', 
              color: 'white'
            }}
            >Free interpreter</Button>
    
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay
            bg='blackAlpha.800'
            backdropFilter='auto'
            backdropBlur='10px'
            />
            <ModalContent 
                border='1px solid black'
                color='black'
                rounded='none'>
            <ModalHeader>Free interpreter service</ModalHeader>
            <ModalCloseButton 
                bg='black'
                border='1px solid black'
                color='white'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }} />
            <ModalBody>
                <Text>HPLS can arrange to speak to you with an interpreter, with no cost to you. Request an interpreter in your language in section 4.</Text>
            </ModalBody>
            <ModalFooter>
                <Button 
                onClick={onClose}
                bg='piacyellow.500'
                border='1px solid black'
                color='black'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }}
                >Close</Button>
            </ModalFooter>
            </ModalContent>
        </Modal>
        </>
    )
    }

    function NeedHelpModal() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    
    return (
        <>
        <Button 
            onClick={onOpen}
            aria-label="Need help filling out the form?"
            bg='piacyellow.500'
            border='1px solid black'
            color='black'
            rounded='none'
            _hover={{ 
              bg: 'piacred.500', 
              color: 'white'
            }}
            >Need help with the form?</Button>
    
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay
                  bg='blackAlpha.700'
                  backdropFilter='auto'
                  backdropBlur='10px'
             />
            <ModalContent 
                border='1px solid black'
                color='black'
                rounded='none'>
            <ModalHeader>Need help filling out the form?</ModalHeader>
            <ModalCloseButton 
                bg='black'
                border='1px solid black'
                color='white'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }} />
            <ModalBody>
                <Text>If you need help filling in this form you can ask a support person to help you, or you can call our office on <strong>(02) 8898 6500</strong>.</Text>
            </ModalBody>
            <ModalFooter>
            <Button 
                onClick={onClose}
                bg='piacyellow.500'
                border='1px solid black'
                color='black'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }}
                >Close</Button>
            </ModalFooter>
            </ModalContent>
        </Modal>
        </>
    )
    }

    function PrivacyModal() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    
    //create link to privacy statement on current host
    const privacyLink = `${currentHost}/privacy-statement/`


    return (
        <>
        <Button onClick={onOpen}
            aria-label="Concerned about privacy?"
            bg='piacyellow.500'
            border='1px solid black'
            color='black'
            rounded='none'
            _hover={{ 
              bg: 'piacred.500', 
              color: 'white'
            }}
        >Your privacy</Button>
    
        <Modal 
            onClose={onClose} 
            isOpen={isOpen} 
            isCentered
            >
            <ModalOverlay
                bg='blackAlpha.700'
                backdropFilter='auto'
                backdropBlur='10px'
             />
            <ModalContent 
                border='1px solid black'
                color='black'
                rounded='none'>
            <ModalHeader>Concerned about privacy?</ModalHeader>
            <ModalCloseButton 
                bg='black'
                border='1px solid black'
                color='white'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }} />
            <ModalBody>
                <Text><strong>All information you provide will be kept private and confidential.</strong> PIAC is committed to protecting the privacy of your information. <a href={privacyLink} rel="noopener noreferrer" target="_blank" onClick={onClose}>Read our privacy statement.</a></Text>
            </ModalBody>
            <ModalFooter>
            <Button 
                onClick={onClose}
                bg='piacyellow.500'
                border='1px solid black'
                color='black'
                rounded='none'
                _hover={{ 
                    bg: 'piacred.500', 
                    color: 'white'
                }}
                >Close</Button>
            </ModalFooter>
            </ModalContent>
        </Modal>
        </>
    )
    }

export default HPLSFormHeader